import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { Observable, catchError, throwError } from 'rxjs';
import { CustomModalComponent } from '@shared-components/custom-modal/custom-modal.component';
import { SubscriptionService } from '@service-features/subscription.service';
import {
  SUBSCRIPTION_REQUIRED_MESSAGE,
  isSubscriptionRequiredError,
} from '../subscription-required';

/**
 * Handles 402 SUBSCRIPTION_REQUIRED once, globally: opens a single dialog
 * with "Suscribirme" and flips the session to read-only. The error is still
 * rethrown so callers stop their loading state; NotificationService skips
 * the generic error toast for this error (see `isSubscriptionRequiredError`).
 */
@Injectable()
export class SubscriptionRequiredInterceptor implements HttpInterceptor {
  private dialogOpen = false;

  constructor(
    private readonly dialog: MatDialog,
    private readonly subscriptionService: SubscriptionService,
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (isSubscriptionRequiredError(error)) {
          this.subscriptionService.markReadOnly();
          this.openDialog();
        }
        return throwError(() => error);
      }),
    );
  }

  private openDialog(): void {
    if (this.dialogOpen) return;
    this.dialogOpen = true;

    this.dialog
      .open(CustomModalComponent, {
        data: {
          title: 'Tu cuenta está en solo lectura',
          message: SUBSCRIPTION_REQUIRED_MESSAGE,
          rejectText: 'Cerrar',
          acceptText: 'Suscribirme',
        },
      })
      .afterClosed()
      .subscribe((accepted: boolean | undefined) => {
        this.dialogOpen = false;
        if (accepted) this.subscriptionService.openCheckout();
      });
  }
}
